import styled from 'styled-components';
const BaseInput = styled.input `
  display: block;
  width: 100%;
  border: 0;
  margin: 0;
  line-height: 24px;
  outline: none;
  background-color: transparent;
  padding: ${({ large }) => (large ? '12px 16px' : '8px 16px')};
  font-size: ${({ theme }) => theme.fontSizes.sizeMd1};
  color: ${({ theme }) => theme.colors.text01};

  ::placeholder {
    color: ${({ theme, placeholderColor }) => placeholderColor || theme.colors.text03};
  }
`;
export default BaseInput;
//# sourceMappingURL=BaseInputText.js.map